import { Formik, Form, ErrorMessage } from 'formik';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Breadcrumb from 'src/components/Common/Breadcrumb'
import InputCom from 'src/components/Common/Input';
import * as Yup from 'yup';
import { ROUTER } from 'src/constants/routes';
import Dropzone from "react-dropzone";
import Button from 'src/components/UI/Button';
import { FieldModal } from 'src/models/components/inputWrapperModel';
import { vehicleBrandsDetails } from 'src/models/pages/vehicleBrandsModel';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from 'src/store/reducers';
import { clearComplaintMessage, clearVehicleBrandsMessage, createComplaintFormLoading, createVehicleBrands, deleteComplaintDocumentLoading, deleteVehicleBrandImageLoading, getComplaintDocumentLoading, getComplaintFormByIdLoading, getPrefixDropdownLoading, getVehicleBrandImageLoading, getVehicleBrandsBYID, resetComplaintMessage, resetVehicleBrand, updateVehicleBrands, uploadVehicleBrandFileLoading } from 'src/store/actions';
import { useToast } from "src/components/Common/ReactToaster";
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import DropdownInput from 'src/components/UI/DropdownInput';
import { FILE_UPLOAD_SIZE } from 'src/constants/commonConstants';
import { onDropRejectedFileHandler } from 'src/helpers/common_helpers';
import { Editor } from 'primereact/editor';
import ErrorText from 'src/components/UI/ErrorText';
import FeatherIcon from "feather-icons-react";
import JobsheetImagePreview from 'src/components/Common/JobsheetImagePreviewer/JobsheetImagePreview';
import FileImg from 'src/assets/images/files.png';
import JobTooltipMEL from 'src/components/UI/JobTooltip';
import PdfImg from 'src/assets/images/PDF-file.png';
import ExcelImg from 'src/assets/images/Excel-file.png';
import ImageFile from 'src/assets/images/Image-file.png';
import VideoImg from 'src/assets/images/video-file.png';
import DeleteModal from '../Calendar/DeleteModal';

const AddEditComplaint: React.FC = () => {
  const { id } = useParams()
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    complaintName: Yup.string().required('Complaint Name is required'),
    jobPrefix: Yup.string().required('Job Prefix is required'),
    complaintPoints: Yup.string().required('Complaint Points is required'),

  });
  

  useEffect(() => {
    if (id) {
      dispatch(getComplaintFormByIdLoading(id));
      dispatch(getComplaintDocumentLoading(id));
    }    
    dispatch(getPrefixDropdownLoading())
    return () => {
      dispatch(resetComplaintMessage())
    }
  }, [id, dispatch]);



  const { error, message, loading, complaintDetails, prefixList,complaintFiles } = useSelector(
    (state: RootReducerState) => state.ComplaintReducer
  );
console.log(complaintFiles,"complaintFilescomplaintFiles")
  const initialvalue = {
    complaintName: (complaintDetails?.['complaintName'] || ""),
    jobPrefix: (complaintDetails?.['jobPrefix'] || ""),
    complaintPoints: (complaintDetails?.['complaintPoints'] || ""),
  }
  
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const quillRef:any = useRef<any>(null);
  const fileInputRef:any = useRef(null);
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (error) {
      setVisible(true)
      setIsSubmitting(false)
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearComplaintMessage())
      setTimeout(() => {
        setIsSubmitting(false)
        if(!message.toLowerCase().includes("deleted")){
        navigate(ROUTER.COMPLAINT_GRID)
      }
      }, 500)
    }
  }, [error, message])

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }

  }, [loading]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearComplaintMessage())
  }

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    )
  }

  const handleSubmit = async (values: any) => {
    if (isSubmitting) return
    const submittedData = {
      complaintName: values.complaintName as string,
      jobPrefix: values.jobPrefix as string,
      complaintPoints: values.complaintPoints as string,
      selectedFiles:selectedFiles.length > 0 ? selectedFiles : []
    }
    setIsSubmitting(true)
    id ? update(submittedData) : post(submittedData);
  };

  const update = (formValue:any) => {
    dispatch(createComplaintFormLoading(formValue, id));
  };


  const post = (formValue:any) => {
    dispatch(createComplaintFormLoading(formValue));
  };

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


  const handleReset = (resetForm: any) => {
    resetForm()
    if (id) {
      navigate(ROUTER.COMPLAINT_GRID)
    }
  }

  const prefixDropdown = useMemo(()=>{
    return prefixList?.filter((data:any)=>data.isDeleted != true)?.map((data:any)=>({
      label:data.jobPrefix,
      value:data.jobPrefix
    }))
  },[prefixList])


const FILE_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB (change if needed)

const insertImageHandler = async (event: any) => {
  const files = Array.from(event.target.files);

  if (files.length === 0) return;

  // Add metadata for preview + type checks
let filesModified = files.map((file: any) => {
  const isImage = file.type.startsWith("image/");
  const isVideo = file.type.startsWith("video/");
  let preview;
 if (isImage) {
    preview = URL.createObjectURL(file); // real image preview
  } else if (pdfMimeTypes.includes(file.type)) {
    preview = PdfImg;
  } else if (excelMimeTypes.includes(file.type)) {
    preview = ExcelImg;
  } else {
    preview = FileImg; // default for unknown docs
  }
  return {
    file, // raw File object (not nested inside itself)
    preview,
    formattedSize: formatBytes(file.size),
    isImage,
    isVideo,
  };
});

  // Validation checks
  const hasVideoFile = filesModified.some((file: any) => file.isVideo);
  const hasImageFileMaxSizeExist = filesModified.some(
    (file: any) => file.size > FILE_UPLOAD_SIZE
  );

  // if (hasVideoFile) {
  //   showToast("Video files are not allowed", { type: "error" });
  //   return;
  // }

  if (hasImageFileMaxSizeExist) {
    showToast("File size exceeds 5MB", { type: "error" });
    return;
  }

  setSelectedFiles((prevFiles: any[]) => [
    ...prevFiles,
    ...filesModified,
  ]);

  // Clear input so same file can be reselected
  event.target.value = null;
};


const handleImageClick = (e:any) => {
  const quill = quillRef.current.getQuill();
    quill.focus();
    const range = quill.getSelection();

  if (range) {
    fileInputRef.current.click();
  } else {
    console.warn("No selection found, please select text to insert an image.");
  }
};

const toolbar = (
  <div id="toolbar">
    <span className="ql-formats">
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <button className="ql-strike"></button>
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
    </span>
    <span className="ql-formats">
        {/* <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
          <button className="ql-image" onClick={(e:any)=>{e.preventDefault();handleImageClick(e)}}>
            <i className="pi pi-image"></i>
          </button>
        </label> */}
        <FeatherIcon icon="file-text" className="p-icon p-chips-token-icon" style={{cursor:"pointer"}} onClick={(e:any) => handleImageClick(e) }/>
      <input
  ref={fileInputRef}
  id="fileInput"
  type="file"
  multiple
  onChange={insertImageHandler}
  style={{ display: "none" }}
/>
      </span>
  </div>
);
const handlePaste = (event:any) => {
  let windows:any=window
  const clipboardData = event.clipboardData || windows.clipboardData;
  const items = clipboardData.items;
  for (let i = 0; i < items.length; i++) {
      if (items[i].kind === 'file' && items[i].type.startsWith('image/')) {
          event.preventDefault();
          return;
      }
  }
};

const deleteConfirmationHandler = (index:any)=>{
  setSelectedFiles((prevFiles: any[]) => prevFiles.filter((file: any) => file !== index));
}

const [deleteModal,setDeleteModal]=useState(false)
const [deleteData,setDeleteData]=useState<any>(null)
const removeIndex = (data:any)=>{
 setDeleteData(data);
 setDeleteModal(true);
}
  const documentTemplate = (franchiseDocumet: any, documentType: any) => {
    return (
      <>
        {
          franchiseDocumet?.length > 0 ? franchiseDocumet?.map((data: any, i: number) => {

            if (pdfMimeTypes.includes(data.mimeType)) {
              return (
                  <Col className='col-auto  img-container' onClick={() => openDocumet(data.fileLink)} key={i}>
                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                    <img src={PdfImg} alt="document" style={{ width: "70px", height: "100px", position:"relative" }} />
                    <div className="delete-icon-complaint">
                       <FeatherIcon onClick={(e:any)=>{ e.stopPropagation(); removeIndex(data)}} icon="trash-2" />
                    </div>
                </JobTooltipMEL>
                  </Col>
              );
            } else if (excelMimeTypes.includes(data.mimeType)) {
              return (
                <Col className='col-auto  img-container' onClick={() => openDocumet(data.fileLink)} key={i}>
                <JobTooltipMEL key={i} title={data.name} position='bottom'> 
                    <img src={ExcelImg} alt="document" style={{ width: "70px", height: "100px", position:"relative" }} />
                    <div className="delete-icon-complaint">
                          <FeatherIcon onClick={(e:any)=>{ e.stopPropagation(); removeIndex(data)}} icon="trash-2" />
                      </div>
                </JobTooltipMEL>
                  </Col>
              );
            } else if (imageMimeTypes.includes(data.mimeType)) {
              return (
                <Col className='col-auto  img-container' onClick={() => openDocumet(data.fileLink)} key={i}>
                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                      {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fas fa-image"></i> */}
                    <img src={data.fileLink} alt="document" style={{ width: "70px", height: "100px", position:"relative" }} />
                    <div className="delete-icon-complaint">
                        <FeatherIcon onClick={(e:any)=>{ e.stopPropagation(); removeIndex(data)}} icon="trash-2" />
                    </div>
                </JobTooltipMEL>
                  </Col>
              );
            }else if (videoMimeTypes.includes(data.mimeType)) {
              return (
                <Col className='col-auto  img-container' onClick={() => openDocumet(data.fileLink)} key={i}>
                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                      {/* <i key={i} onClick={() => openDocumet(data.fileLink)} className="fas fas fa-image"></i> */}
                    <img src={VideoImg} alt="document" style={{ width: "70px", height: "100px", position:"relative" }} />
                    <div className="delete-icon-complaint">
                        <FeatherIcon onClick={(e:any)=>{ e.stopPropagation(); removeIndex(data)}} icon="trash-2" />
                    </div>
                </JobTooltipMEL>
                  </Col>
              );
            }  else {
              return (
                  <Col className='col-auto  img-container' onClick={() => openDocumet(data.fileLink)} key={i}>
                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                  {/* <i key={i} onClick={() => openDocumet(data.id, documentType)} className="fas fa-file-alt"></i> */}
                    <img src={FileImg} alt="document" style={{ width: "70px", height: "100px", position:"relative" }} />
                    <div className="delete-icon-complaint">
                                                <FeatherIcon onClick={(e:any)=>{ e.stopPropagation(); removeIndex(data)}} icon="trash-2" />
                                            </div>
                                            </JobTooltipMEL>
                  </Col>
              );
            }
          }) : <span style={{ fontSize: "14px" }}>No attachement here</span>
        }
        </>
    );
  };

  const deleteIMage=()=>{
    if(deleteData){
      debugger
      dispatch(deleteComplaintDocumentLoading(id,deleteData.id));
      setDeleteData(null)
      setDeleteModal(false)
    }
  }
  return (
    <React.Fragment>
           <DeleteModal
             show={deleteModal}
             onDeleteClick={() => {
               deleteIMage();
             }}
             onCloseClick={() => {
                setDeleteData(null)
                setDeleteModal(false)
             }}
           />
      {visible && dialogContainer(error)}
      <div className="page-content" id="view-brand">
        <Container fluid>
          <Breadcrumb title="Complaint" titlePath={ROUTER.COMPLAINT_GRID} breadcrumbItem={`${id ? "Edit Complaint" : "Create Complaint"}`} />
          <Row>
            <Card>
              <CardBody>
                <React.Fragment>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialvalue}
                    validationSchema={validationSchema}
                    enableReinitialize>
                    {({ values, handleChange, touched, errors, handleBlur,setFieldValue, resetForm, reset, ...rest }: any) => {
                      return (
                        <Form onChange={handleChange}>
                          <Row>
                            
                            <Col lg={2} >
                              <DropdownInput
                                options={prefixDropdown}
                                name="jobPrefix"
                                label="Job Prefix"
                                onChange={(e:any)=>{
                                  handleChange(e)
                                }}
                                onBlur={handleBlur}
                                required={true}
                                value={values.jobPrefix}
                                invalid={
                                  touched["jobPrefix"] && errors["jobPrefix"]
                                    ? true
                                    : false
                                } />

                            </Col>
                            <Col lg={4} >
                              <InputCom labelName="Complaint Name"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="complaintName"
                                onBlur={handleBlur}
                                value={values.complaintName}
                                onChange={handleChange}
                                isRequired={true}
                                invalid={touched["complaintName"] && errors["complaintName"] ? true : false}
                              />

                            </Col>

                             <Col lg={12} className="mt-2">
                              <label htmlFor="complaintPoints">Complaint Points<span className="text-danger ml-05">*</span></label>
                              <Editor
                                id="complaintPoints"
                                name="complaintPoints"
                                value={values.complaintPoints}
                                onTextChange={(e) => setFieldValue('complaintPoints', e.htmlValue)}
                                style={{ height: "320px" }}
                                className={  errors["complaintPoints"] ? "is-invalid-editor" : ""}
                                headerTemplate={toolbar}
                                ref={quillRef}
                                onPaste={(e:any)=>handlePaste(e)}
                              />
                                <ErrorMessage name={"complaintPoints"} component={ErrorText} />
                              
                            </Col>
                             <JobsheetImagePreview selectedFiles={selectedFiles.length > 0 ? selectedFiles : []} removeIndex={deleteConfirmationHandler} />
                              {
                                complaintFiles && complaintFiles.length > 0 && 
                                                <div className="dropzone-previews " id="file-previews_jobsheet">
            <div
                className="mb-0 shadow-none dz-processing dz-image-preview dz-success dz-complete"
                key={"file"}
            >
              <div className="p-2">
                                  <Row className="align-items-center">
                                {documentTemplate(complaintFiles?.filter((file:any) => file.isUploaded === true),"complaint")}
                                </Row></div></div></div>
                              }
                            <div className="d-flex justify-content-end mt-2">
                              <Button
                                className="secondary-btn me-2"
                                label={id ? "Cancel" : "Reset"}
                                type="button"
                                onClick={() => handleReset(resetForm)}
                              />
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label={id ? "Update Complaint" : "Create Complaint"}
                                type="submit"
                              />
                            </div>

                          </Row>


                        </Form>
                      )
                    }}
                  </Formik>
                </React.Fragment>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddEditComplaint
const imageMimeTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp", "image/avif", "image/tiff", "image/svg+xml"];
  const pdfMimeTypes = ["application/pdf"];
  const excelMimeTypes = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"];
  const videoMimeTypes = ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-ms-wmv", "video/mpeg", "video/x-flv", "video/webm", "video/ogg", "video/3gpp", "video/3gpp2"];

  const openDocumet=(link:any)=>{
    if (link != "" && link != undefined && link != null) {
          const newWindow = window.open(link);
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            alert('Popup blocked! Please allow popups for this site to view the document.');
          } else {
            newWindow.focus();
          }
        }
  }

